// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "home" + "." + "a7fbfb32" + ".chunk.css";
};